<div class="team-select" id="team-select">
  <mat-tab-group mat-stretch-tabs (selectedTabChange)="selectionChanged($event)" class="tab-group">
    <mat-tab *ngFor="let mitarbeiter of employees$ | async">
      <ng-template class="labels" mat-tab-label>
        <div class="label-content">{{ mitarbeiter.getFullName() }}</div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
